import axios from "axios";

const baseURL = "https://app.phorm.com.br:3001";

const configAxios = axios.create({
  baseURL,
});

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  throw error;
};

configAxios.interceptors.request.use(
  (request) => {
    const headers = {
      authorization:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55IjoiUEhPUk0iLCJpYXQiOjE3MjY1ODE4NzgsImV4cCI6MTc2MDgwMTA3M30.R3F6IP1D7Rx1bEzNMubhgoC-dZDF4SMGHt1GMTemmnY",
    };

    request.headers = headers;
    return requestHandler(request);
  },
  (error) => errorHandler(error)
);

configAxios.interceptors.response.use(
  (response) => {
    return responseHandler(response);
  },
  (error) => {
    errorHandler(error);
  }
);

export default configAxios;
